import React from "react";
import { Helmet } from "react-helmet";
import {
  ADDRESS,
  ADDRESS_TEXT,
  CONTACT_US,
  EMAIL,
  EMAIL_TEXT,
  FIX_LINE,
  FIX_LINE_NO,
  P_O_BOX,
  P_O_BOX_NO,
} from "../../constants/translations";
import shipImage from "../../asset/images/contactUs/ship.jpg";
import {
  IoIosCall,
  IoIosGlobe,
  IoIosMail,
  IoIosMailUnread,
} from "react-icons/io";
const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>{CONTACT_US}</title>
      </Helmet>
      <div className="contact-us-page-wrapper">
        <div className="image-wrapper">
          <img src={shipImage} alt="Contact us" width={664} height={664} />
        </div>
        <div className="contact-infos">
          <div className="content-controller">
            <div className="contact-info">
              <span className="icon-place">
                <IoIosGlobe />
              </span>
              <div className="text-content">
                <p className="info-title">{ADDRESS}</p>
                <p className="info-content">{ADDRESS_TEXT}</p>
              </div>
            </div>
            <div className="contact-info">
              <span className="icon-place">
                <IoIosMail />
              </span>
              <div className="text-content">
                <p className="info-title">{P_O_BOX}</p>
                <p className="info-content">{P_O_BOX_NO}</p>
              </div>
            </div>
            <div className="contact-info">
              <span className="icon-place">
                <IoIosMailUnread />
              </span>
              <div className="text-content">
                <p className="info-title">{EMAIL}</p>
                <a
                  href={`mailto:${EMAIL_TEXT.toLowerCase()}`}
                  className="info-content"
                >
                  {EMAIL_TEXT}
                </a>
              </div>
            </div>
            <div className="contact-info">
              <span className="icon-place">
                <IoIosCall />
              </span>
              <div className="text-content">
                <p className="info-title">{FIX_LINE}</p>
                <a href={`tel:+97144567272`} className="info-content">
                  {FIX_LINE_NO}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
